import React from "react";
import { Grid } from "@material-ui/core";
import InputField from "src/components/ui-components/InputField";
import SwitchField from "src/components/ui-components/SwitchField";

const SubMenuFilterValueCreateEdit = ({
  pages,
  index,
  indexFilter,
  indexFilterValue,
}) => {
  return (
    <>
      <Grid container spacing={5}>
        <Grid item xs={6}>
          <InputField
            label="Sub Menu Filter Value Name"
            name={`pages.${index}.pageFilter.${indexFilter}.pageFilterValues.${indexFilterValue}.pageFilterValueName`}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Sub Menu Filter Value"
            name={`pages.${index}.pageFilter.${indexFilter}.pageFilterValues.${indexFilterValue}.pageFilterValue`}
          />
        </Grid>
        <Grid item xs={6}>
          <InputField
            label="Sort Order"
            name={`pages.${index}.pageFilter.${indexFilter}.pageFilterValues.${indexFilterValue}.sortOrder`}
          />
        </Grid>
        <Grid item xs={3}>
          <SwitchField
            name={`pages.${index}.pageFilter.${indexFilter}.pageFilterValues.${indexFilterValue}.isDefault`}
            label="Is Default"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SubMenuFilterValueCreateEdit;
